import { render, staticRenderFns } from "./PartnerDetailView.vue?vue&type=template&id=461d7e8d"
import script from "./PartnerDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerDetailView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports